import * as types from '../actions/actiontype';
import * as appUtility from '../../../infrastructure/apputilityfunctions';

const initialState = {
}

initialState.communicationUserEntry = {
    mobileNo: null,
    prefLanguage: null,
    productType: null,
    serviceType: null,
    Remarks: null,
}


initialState.communicationModuleSearch = {
    mobileNo: null,
    productType: null,
    serviceType: null,
    createdDate: null,
    closedDate: null,
    statusId: null,
    requestNo: null,
    asnicRefNo: null,
    showSearchResults: false,
    searchResults: []
}

initialState.communicationModuleEntry = {
    mobileNo: null,
    productType: null,
    serviceType: null,
    createdDate: null,
    closedDate: null,
    statusId: null,
    requestNo: null,
    asnicRefNo: null,
}

initialState.gernerateUserLink = {
    ulMobileNumber: null,
    ulPreferredLanguage: null,
    productTypeId: null,
    serviceTypeId: null,
    ulRemarks: null,
}

initialState.communicationMaster = {
    mcProductTypeId: null,
    mcServiceTypeId: null,
    mcPreferredLanguageType: null,
    mcStatusTypeId: null,
    mcStatusTypeName: null,
    mcAgreeTermsConditions: null,
    mcIsSubmittedYn: null,
    mcCreatedByName: null,
    mcName: null,
    mcMobileNumber: null,
    mcNumber: null,
    mcSlNo: null,
    mcEmailId: null,
    mcLinkId: null,
    mcUlId: null,
    mcRemarks: null,
    mcCreatedDate: null,
    mcId: null,

}

initialState.communicationTaskAssign = {
    commId: null,
    masterId: null,
    assignedStatusId: null,
    recipientGroupId: null,
    remarks: null,
    srlNo: null,
    processSrlNo: null,
    assignedUsersDto: [],
    communicationRecords: []
}

initialState.modalsState = {
    showEnterUserDetails: false,
    showCreateLinkDetails: false,
    showCommunicationMaster: false,
    showAttachments: false,
    showCommunications: false,
}

initialState.masters = {
    productsList: [],
    productServiceLink: [],
    statusList: [],
    documentsMasterList: [],
    groupList: [],
    userList: [],
    communicationServiceDocumentList: [],
    productServiceDocConfig: [],
}
initialState.communicationDocuments = {
    documentList: [],
    selectedDocuments: [],
}
initialState.userEntry = {
    linkId: null,
    mobileNo: null,
    isValidated: null,
    mcId: null,
    otpCode: null,
    otpCodeSent: null,
}
initialState.userEntryDetails = {
    userMobileNo: null,
    userName: null,
    userEmail: null,
    userProductTypeId: null,
    userSserviceTypeId: null,
    userRemarks: null,
    mcId: null,
    mcLinkId: null,
    prefLanguage: null,
    isSubmitted: null,
    termsCheckbox: null,
    agreeTerms: null,
    coreSystemRemarks: null,
    statusTypeId: null,
    vehCategory: null,
    isVehicleFinanced: null,
    vehType: null,
    validForSubmission: null,
}
initialState.getQuoteOnlineDetails = {
    userMobileNo: null,
    userName: null,
    userEmail: null,
    preferredLanguage: "ENG",
    userProductTypeId: null,
    userServiceTypeId: null,
    userRemarks: null,
    mcId: null,
    mcLinkId: null,
    prefLanguage: null,
    isSubmitted: null,
    termsCheckbox: null,
    agreeTerms: null,
    coreSystemRemarks: null,
    statusTypeId: null,
    vehCategory: null,
    isVehicleFinanced: null,
    vehType: null,
    validForSubmission: null,
    utmSourceName: null,
}
initialState.getQuoteOnlineDocuments = {
    documentList: [],
    selectedDocuments: [],
}

initialState.confirmPopup = {
    showConfirmPopup: false,
    message: null,
    resolve: null,
    showYes: false,
    showNo: false,
    showOk: false,
    isComp: false,

}
export default function communicationModuleReducer(state = initialState, action) {
    switch (action.type) {

        case types.SET_COMMUNICATION_MODULE_MASTERS:
            return {
                ...state,
                masters: {
                    ...state.masters,
                    productsList: action.result.productsList,
                    productServiceLink: action.result.productServiceLink,
                    statusList: action.result.statusList,
                    groupList: action.result.groupList,
                    userList: action.result.userList,
                    documentsMasterList: action.result.communicationDocumentsMaster,
                    communicationServiceDocumentList: action.result.communicationServiceDocumentListDto,
                    productServiceDocConfig: action.result.productServiceDocConfig,
                }
            }

        case types.SET_MODAL_STATE:
            return {
                ...state,
                modalsState: {
                    ...state.modalsState,
                    [action.payload.name]: action.payload.value
                }
            }

        case types.UPDATE_MODAL_DISPLAY_STATE_REPORT_ENGINE: {
            return {
                ...state,
                modalsState: {
                    ...state.modalsState,
                    [action.payload.name]: action.payload.value
                }
            }
        }

        // case types.SET_COMPLAINT_LEGAL_MASTERS:
        //     return {
        //         ...state,
        //         masters: {
        //             ...state.masters,
        //             legalLawyerMasters: action.result.legalLawyerMasters,
        //             legalCourtMasters: action.result.legalCourtMasters,
        //             legalDefendantMasters: action.result.legalDefendantMasters,
        //             legalCaseStatusMasters: action.result.legalCaseStatusMasters,
        //             legalCaseTypeMasters: action.result.legalCaseTypeMasters,
        //             legalCaseSubjectMasters: action.result.legalCaseSubjectMasters,
        //             legalAccessUsers: action.result.legalAccessUsers
        //         }
        //     }
        case types.UPDATE_COMMUNICATION_MODULE_PARAMS:
            return {
                ...state,
                communicationModuleSearch: {
                    ...state.communicationModuleSearch,
                    [action.payload.name]: action.payload.value
                }
            }
        case types.RESET_COMMUNICATION_MODULE_PARAMS:

            return {
                ...state,
                communicationModuleSearch: {
                    mobileNo: null,
                    productType: null,
                    serviceType: null,
                    createdDate: null,
                    closedDate: null,
                    statusId: null,
                    requestNo: null,
                    asnicRefNo: null,
                    showSearchResults: false,
                    searchResults: [],
                },
                communicationMaster: {
                    mcProductTypeId: null,
                    mcServiceTypeId: null,
                    mcPreferredLanguageType: null,
                    mcStatusTypeId: null,
                    mcStatusTypeName: null,
                    mcAgreeTermsConditions: null,
                    mcIsSubmittedYn: null,
                    mcCreatedByName: null,
                    mcName: null,
                    mcMobileNumber: null,
                    mcNumber: null,
                    mcSlNo: null,
                    mcEmailId: null,
                    mcLinkId: null,
                    mcUlId: null,
                    mcRemarks: null,
                    mcCreatedDate: null,
                    mcId: null,

                }, communicationDocuments: {
                    documentList: [],
                    selectedDocuments: [],
                }, communicationTaskAssign: {
                    commId: null,
                    masterId: null,
                    assignedStatusId: null,
                    recipientGroupId: null,
                    remarks: null,
                    srlNo: null,
                    processSrlNo: null,
                    assignedUsersDto: [],
                    communicationRecords: []
                }, modalsState: {
                    showEnterUserDetails: false,
                    showCreateLinkDetails: false,
                    showCommunicationMaster: false,
                    showAttachments: false,
                    showCommunications: false,
                }
            }
        case types.UPDATE_COMMUNICATION_SEARCH_RESULT:
            return {
                ...state,
                communicationModuleSearch: {
                    ...state.communicationModuleSearch,
                    searchResults: action.pagedResult,
                    showSearchResults: true
                }
            }

        case types.SET_CREATE_LINK_PARAMS:
            return {
                ...state,
                gernerateUserLink: {
                    ...state.gernerateUserLink,
                    [action.payload.name]: action.payload.value
                }
            }
        case types.RESET_CREATE_LINK_PARAMS:
            return {
                ...state,
                gernerateUserLink: {
                    ...state.gernerateUserLink,
                    ulMobileNumber: null,
                    ulPreferredLanguage: null,
                    productTypeId: null,
                    serviceTypeId: null,
                    ulRemarks: null,
                }
            }


        case types.GET_CURRENT_MASTER_COMM_END:

            return {
                ...state,
                communicationMaster: {
                    ...state.communicationMaster,
                    mcProductTypeId: action.payload.result == null ? null : action.payload.result.mcProductTypeId,
                    mcServiceTypeId: action.payload.result == null ? null : action.payload.result.mcServiceTypeId,
                    mcPreferredLanguageType: action.payload.result == null ? null : action.payload.result.mcPreferredLanguageType,
                    mcStatusTypeId: action.payload.result == null ? null : action.payload.result.mcStatusTypeId,
                    mcStatusTypeName: action.payload.result == null ? null : action.payload.result.mcStatusTypeName,
                    mcAgreeTermsConditions: action.payload.result == null ? null : action.payload.result.mcAgreeTermsConditions,
                    mcIsSubmittedYn: action.payload.result == null ? null : action.payload.result.mcIsSubmittedYn,
                    mcCreatedByName: action.payload.result == null ? null : action.payload.result.mcCreatedByName,
                    mcId: action.payload.result == null ? null : action.payload.result.mcId,
                    mcCreatedById: action.payload.result == null ? null : action.payload.result.mcCreatedById,
                    mcCreatedDate: action.payload.result == null ? null : action.payload.result.mcCreatedDate == null ? null : appUtility.formatDate(action.payload.result.mcCreatedDate),
                    mcUpdatedByName: action.payload.result == null ? null : action.payload.result.mcUpdatedByName,
                    mcUpdatedById: action.payload.result == null ? null : action.payload.result.mcUpdatedById,
                    mcUpdatedDate: action.payload.result == null ? null : action.payload.result.mcUpdatedDate,
                    mcName: action.payload.result == null ? null : action.payload.result.mcName,
                    mcMobileNumber: action.payload.result == null ? null : action.payload.result.mcMobileNumber,
                    mcNumber: action.payload.result == null ? null : action.payload.result.mcNumber,
                    mcSlNo: action.payload.result == null ? null : action.payload.result.mcSlNo,
                    mcEmailId: action.payload.result == null ? null : action.payload.result.mcEmailId,
                    mcLinkId: action.payload.result == null ? null : action.payload.result.mcLinkId,
                    mcUlId: action.payload.result == null ? null : action.payload.result.mcUlId,
                    mcRemarks: action.payload.result == null ? null : action.payload.result.mcRemarks,
                }
            }
        case types.UPDATE_COMMUNICATION_DOCUMENT_PARAMS: {
            console.log("Confirmed", action.payload);
            return {
                ...state,
                communicationDocuments: {
                    ...state.communicationDocuments,
                    documentList: (state.communicationDocuments?.documentList).map(doc => {
                        if (doc.srlNo === action.payload.srlno) {
                            return {
                                ...doc,
                                field: action.payload.field,
                                fileType: action.payload.type,
                                cimId: action.payload.intimationId,
                                srlNo: action.payload.srlno, // ✅ fixed case
                                fileName: action.payload.name,
                                fileInput: action.payload.docIdEncrypted,
                                attachmentPath: action.payload.docIdEncrypted,
                                uploadedDate: action.payload.date
                            };
                        }
                        return doc;
                    })
                }
            };
        }
        case types.UPDATE_COMMUNICATION_DOCUMENT_DOCUMENT_PARAMS: {
            return {
                ...state,
                communicationDocuments: {
                    ...state.communicationDocuments,
                    documentList: state.communicationDocuments.documentList.map(doc => {
                        if (doc.srlNo === action.payload.srlNo) {
                            return {
                                ...doc,
                                [action.payload.name]: action.payload.value
                            };
                        }
                        return doc;
                    })
                }
            };
        }
        case types.ADD_NEW_COMMUNICATION_DOCUMENT: {
            // let documentCount = state.documents.documentList.length;
            const highestSrlNo = state.communicationDocuments.documentList.reduce((max, doc) => (doc.srlNo > max ? doc.srlNo : max), 0);

            return {
                ...state,
                communicationDocuments: {
                    ...state.communicationDocuments,
                    documentList: [
                        ...state.communicationDocuments.documentList,
                        {
                            srlNo: highestSrlNo + 1,
                            CmdId: 0,
                            mcId: state.communicationMaster.mcId,
                            attachmentDoctype: null,
                            attachmentRefno: null,
                            remarks: null,
                            fileType: null,
                            fileName: null,
                            attachmentPath: null,
                            createdByName: null,
                            uploadedDate: null,
                            updatedByName: null,
                            updatedDt: null,
                            createdById: null,
                            updatedById: null,
                            documentMasterId: 50,
                            documentName: null
                        }
                    ]
                }
            };
        }
        case types.GET_COMMUNICATION_DOCUMENTS_END: {
            return {
                ...state,
                communicationDocuments: {
                    ...state.communicationDocuments,
                    documentList: action.payload ?? []
                },
            };
        }
        case types.RESET_COMMUNICATION_MODULE_MASTER_PARAMS:
            return {
                ...state,
                communicationMaster: {

                    mcProductTypeId: null,
                    mcServiceTypeId: null,
                    mcPreferredLanguageType: null,
                    mcStatusTypeId: null,
                    mcStatusTypeName: null,
                    mcAgreeTermsConditions: null,
                    mcIsSubmittedYn: null,
                    mcCreatedByName: null,
                    mcName: null,
                    mcMobileNumber: null,
                    mcNumber: null,
                    mcSlNo: null,
                    mcEmailId: null,
                    mcLinkId: null,
                    mcUlId: null,
                    mcRemarks: null,
                    mcCreatedDate: null,
                    mcId: null,


                },
                communicationDocuments: {

                    documentList: [],
                    selectedDocuments: [],

                }
            }

        case types.RESET_COMMUNICATION_TASK_ASSIGNMENT:
            return {
                ...state,
                communicationTaskAssign: {
                    ...state.communicationTaskAssign,
                    // masterId: null,
                    assignedStatusId: null,
                    commId: null,
                    recipientGroupId: null,
                    remarks: null,
                    srlNo: null,
                    processSrlNo: null,
                    assignedUsersDto: [],
                },
            };

        case types.SET_COMMUNICATION_TASK_ASSIGN_ENTRY_PARAMS:
            return {
                ...state,
                communicationTaskAssign: {
                    ...state.communicationTaskAssign,
                    [action.payload.name]: action.payload.value
                }
            }
        case types.GET_COMMUNICATIONS_LOG_END:
            console.log("srv2", action.payload)
            return {
                ...state,
                communicationTaskAssign: {
                    ...state.communicationTaskAssign,
                    communicationRecords: action.payload ?? []
                }
            }

        case types.ON_CHANGE_USER_OTP_PARAMS:
            return {
                ...state,
                userEntry: {
                    ...state.userEntry,
                    [action.payload.name]: action.payload.value
                }
            }
        case types.GET_CURRENT_MASTER_COMM_FOR_USER_ENTRY_END:
            return {
                ...state,
                userEntryDetails: {
                    ...state.userEntryDetails,
                    userName: action.payload.result == null ? null : action.payload.result.mcName,
                    userMobileNo: action.payload.result == null ? null : action.payload.result.mcMobileNumber,
                    userEmail: action.payload.result == null ? null : action.payload.result.mcEmailId,
                    mcLinkId: action.payload.result == null ? null : action.payload.result.mcLinkId,
                    userProductTypeId: action.payload.result == null ? null : action.payload.result.mcProductTypeId,
                    userSserviceTypeId: action.payload.result == null ? null : action.payload.result.mcServiceTypeId,
                    prefLanguage: action.payload.result == null ? null : action.payload.result.userPrefLanguage,
                    userRemarks: action.payload.result == null ? null : action.payload.result.mcRemarks,
                    isSubmitted: action.payload.result == null ? null : action.payload.result.isSubmitted,
                    mcId: action.payload.result == null ? null : action.payload.result.mcId,
                    agreeTerms: action.payload.result == null ? null : action.payload.result.agreeTerms,
                    termsCheckbox: action.payload.result == null ? null : action.payload.result.agreeTerms,
                    coreSystemRemarks: action.payload.result == null ? null : action.payload.result.coreSystemRemarks,
                    statusTypeId: action.payload.result == null ? null : action.payload.result.statusTypeId,
                    vehCategory: action.payload.result == null ? null : action.payload.result.vehCategory,
                    isVehicleFinanced: action.payload.result == null ? null : action.payload.result.isVehicleFinanced,
                    vehType: action.payload.result == null ? null : action.payload.result.vehType,
                    validForSubmission: action.payload.result == null ? null : action.payload.result.validForSubmission,
                },
                communicationDocuments: {
                    ...state.communicationDocuments,
                    documentList: action.payload.result.documentsList ?? []
                },
                /*masters: {
                    ...state.masters,
                    documentsMasterList: action.payload.result.communicationDocumentsMaster,
                },*/
            }
        case types.ON_CHANGE_USER_DETAILS_PARAMS:
            return {
                ...state,
                userEntryDetails: {
                    ...state.userEntryDetails,
                    [action.payload.name]: action.payload.value
                }
            }
        case types.RESET_COMMUNICATION_MODULE_PARAMS_EXCEPT_SEARCH:

            return {
                ...state,

                communicationMaster: {
                    mcProductTypeId: null,
                    mcServiceTypeId: null,
                    mcPreferredLanguageType: null,
                    mcStatusTypeId: null,
                    mcStatusTypeName: null,
                    mcAgreeTermsConditions: null,
                    mcIsSubmittedYn: null,
                    mcCreatedByName: null,
                    mcName: null,
                    mcMobileNumber: null,
                    mcNumber: null,
                    mcSlNo: null,
                    mcEmailId: null,
                    mcLinkId: null,
                    mcUlId: null,
                    mcRemarks: null,
                    mcCreatedDate: null,
                    mcId: null,

                }, communicationDocuments: {
                    documentList: [],
                    selectedDocuments: [],
                }, communicationTaskAssign: {
                    commId: null,
                    masterId: null,
                    assignedStatusId: null,
                    recipientGroupId: null,
                    remarks: null,
                    srlNo: null,
                    processSrlNo: null,
                    assignedUsersDto: [],
                    communicationRecords: []
                }, modalsState: {
                    showEnterUserDetails: false,
                    showCreateLinkDetails: false,
                    showCommunicationMaster: false,
                    showAttachments: false,
                    showCommunications: false,
                }
            }


        case types.UPDATE_DOCUMENTS_LIST_ON_FRONT:

            let configVehType = state.userEntryDetails.vehType ?? "NA";
            let configMortgageYn = state.userEntryDetails.isVehicleFinanced ?? "NA";
            let configCategoryType = state.userEntryDetails.vehCategory ?? "NA";

            var configId = state.masters.productServiceDocConfig.filter(p => p.configProductTypeId == state.userEntryDetails.userProductTypeId
                && p.configServiceTypeId == state.userEntryDetails.userSserviceTypeId && p.configVehType == configVehType
                && p.configMortgageYn == configMortgageYn && p.configCategoryType == configCategoryType)[0]?.configDocId;
            const safeValue = Number.isFinite(configId) ? configId : 0;

            if (safeValue == 0) {
                return state;
            }
            let newDocsList = state.masters.communicationServiceDocumentList.filter(p => p.docConfigId == safeValue);

            const result = [];

            for (let i = 0; i < newDocsList.length; i++) {

                var r = {
                    srlNo: i,
                    CmdId: 0,
                    mcId: state.communicationMaster.mcId,
                    attachmentDoctype: null,
                    attachmentRefno: null,
                    remarks: null,
                    fileType: null,
                    fileName: null,
                    attachmentPath: null,
                    createdByName: null,
                    uploadedDate: null,
                    updatedByName: null,
                    updatedDt: null,
                    createdById: null,
                    updatedById: null,
                    documentMasterId: newDocsList[i].documentId,
                    documentName: null
                };
                result.push(r);
            }

            return {
                ...state,
                communicationDocuments: {
                    ...state.communicationDocuments,
                    documentList: result
                    // [action.payload.name]: action.payload.value
                }
            }

        case types.GET_CURRENT_MASTER_COMM_FOR_GET_QUOTE_ONLINE_END:
            return {
                ...state,
                getQuoteOnlineDetails: {
                    ...state.getQuoteOnlineDetails,
                    userName: action.payload.result == null ? null : action.payload.result.mcName,
                    userMobileNo: action.payload.result == null ? null : action.payload.result.mcMobileNumber,
                    userEmail: action.payload.result == null ? null : action.payload.result.mcEmailId,
                    mcLinkId: action.payload.result == null ? null : action.payload.result.mcLinkId,
                    userProductTypeId: action.payload.result == null ? null : action.payload.result.mcProductTypeId,
                    userSserviceTypeId: action.payload.result == null ? null : action.payload.result.mcServiceTypeId,
                    prefLanguage: action.payload.result == null ? null : action.payload.result.userPrefLanguage,
                    userRemarks: action.payload.result == null ? null : action.payload.result.mcRemarks,
                    isSubmitted: action.payload.result == null ? null : action.payload.result.isSubmitted,
                    mcId: action.payload.result == null ? null : action.payload.result.mcId,
                    agreeTerms: action.payload.result == null ? null : action.payload.result.agreeTerms,
                    termsCheckbox: action.payload.result == null ? null : action.payload.result.agreeTerms,
                    coreSystemRemarks: action.payload.result == null ? null : action.payload.result.coreSystemRemarks,
                    statusTypeId: action.payload.result == null ? null : action.payload.result.statusTypeId,
                    vehCategory: action.payload.result == null ? null : action.payload.result.vehCategory,
                    isVehicleFinanced: action.payload.result == null ? null : action.payload.result.isVehicleFinanced,
                    vehType: action.payload.result == null ? null : action.payload.result.vehType,
                    validForSubmission: action.payload.result == null ? null : action.payload.result.validForSubmission,
                },
                getQuoteOnlineDocuments: {
                    ...state.getQuoteOnlineDocuments,
                    documentList: action.payload.result.documentsList ?? []
                },
            }
        case types.ON_CHANGE_GET_QUOTE_ONLINE_DETAILS_PARAMS:
            return {
                ...state,
                getQuoteOnlineDetails: {
                    ...state.getQuoteOnlineDetails,
                    [action.payload.name]: action.payload.value
                }
            }

        case types.UPDATE_GET_QUOTE_ONLINE_DOCUMENTS_LIST_ON_FRONT:

            let gqoConfigVehType = state.getQuoteOnlineDetails.vehType ?? "NA";
            let gqoConfigMortgageYn = state.getQuoteOnlineDetails.isVehicleFinanced ?? "NA";
            let gqoConfigCategoryType = state.getQuoteOnlineDetails.vehCategory ?? "NA";

            var gqoConfigId = state.masters.productServiceDocConfig.filter(p => p.configProductTypeId == state.getQuoteOnlineDetails.userProductTypeId
                && p.configServiceTypeId == state.getQuoteOnlineDetails.userSserviceTypeId && p.configVehType == gqoConfigVehType
                && p.configMortgageYn == gqoConfigMortgageYn && p.configCategoryType == gqoConfigCategoryType)[0]?.configDocId;
            const gqoSafeValue = Number.isFinite(gqoConfigId) ? gqoConfigId : 0;

            if (gqoSafeValue == 0) {
                return state;
            }
            let gqoNewDocsList = state.masters.communicationServiceDocumentList.filter(p => p.docConfigId == gqoSafeValue);

            const gqoResult = [];

            for (let i = 0; i < gqoNewDocsList.length; i++) {

                var r = {
                    srlNo: i,
                    CmdId: 0,
                    mcId: state.getQuoteOnlineDetails.mcId,
                    attachmentDoctype: null,
                    attachmentRefno: null,
                    remarks: null,
                    fileType: null,
                    fileName: null,
                    attachmentPath: null,
                    createdByName: null,
                    uploadedDate: null,
                    updatedByName: null,
                    updatedDt: null,
                    createdById: null,
                    updatedById: null,
                    documentMasterId: gqoNewDocsList[i].documentId,
                    documentName: null
                };
                gqoResult.push(r);
            }

            return {
                ...state,
                getQuoteOnlineDocuments: {
                    ...state.getQuoteOnlineDocuments,
                    documentList: gqoResult
                }
            }

        // Get Quote Online company website feature

        case types.ON_CHANGE_GET_QUOTE_ONLINE_DETAILS_PARAMS: {
            return {
                ...state,
                getQuoteOnlineDetails: {
                    ...state.getQuoteOnlineDetails,
                    [action.payload.name]: action.payload.value
                }
            }
        }
        case types.RESET_GET_QUOTE_ONLINE_MASTER_PARAMS: {
            return {
                ...state,
                getQuoteOnlineDetails: {
                    ...state.getQuoteOnlineDetails,
                    userMobileNo: null,
                    userName: null,
                    userEmail: null,
                    preferredLanguage: "ENG",
                    userProductTypeId: null,
                    userServiceTypeId: null,
                    userRemarks: null,
                    mcId: null,
                    mcLinkId: null,
                    prefLanguage: null,
                    isSubmitted: null,
                    termsCheckbox: null,
                    agreeTerms: null,
                    coreSystemRemarks: null,
                    statusTypeId: null,
                    vehCategory: null,
                    isVehicleFinanced: null,
                    vehType: null,
                    validForSubmission: null,
                    //utmSourceName: null,
                }
            }
        }


        case types.UPDATE_GET_QUOTE_ONLINE_DOCUMENTS_LIST_ON_FRONT: {

            let gqoConfigVehType = state.getQuoteOnlineDetails.vehType ?? "NA";
            let gqoConfigMortgageYn = state.getQuoteOnlineDetails.isVehicleFinanced ?? "NA";
            let gqoConfigCategoryType = state.getQuoteOnlineDetails.vehCategory ?? "NA";

            var gqoConfigId = state.masters.productServiceDocConfig.filter(p => p.configProductTypeId == state.getQuoteOnlineDetails.userProductTypeId
                && p.configServiceTypeId == state.getQuoteOnlineDetails.userServiceTypeId && p.configVehType == gqoConfigVehType
                && p.configMortgageYn == gqoConfigMortgageYn && p.configCategoryType == gqoConfigCategoryType)[0]?.configDocId;
            const gqoSafeValue = Number.isFinite(gqoConfigId) ? gqoConfigId : 0;

            if (gqoSafeValue == 0) {
                return state;
            }
            let gqoNewDocsList = state.masters.communicationServiceDocumentList.filter(p => p.docConfigId == gqoSafeValue);

            const gqoResult = [];

            for (let i = 0; i < gqoNewDocsList.length; i++) {

                var r = {
                    srlNo: i,
                    CmdId: 0,
                    mcId: state.getQuoteOnlineDetails.mcId,
                    attachmentDoctype: null,
                    attachmentRefno: null,
                    remarks: null,
                    fileType: null,
                    fileName: null,
                    attachmentPath: null,
                    createdByName: null,
                    uploadedDate: null,
                    updatedByName: null,
                    updatedDt: null,
                    createdById: null,
                    updatedById: null,
                    documentMasterId: gqoNewDocsList[i].documentId,
                    documentName: null
                };
                gqoResult.push(r);
            }

            return {
                ...state,
                getQuoteOnlineDocuments: {
                    ...state.getQuoteOnlineDocuments,
                    documentList: gqoResult
                }
            }
        }
         case types.TOGGLE_CONFRIM_POPUP:
                            return {
                                ...state,
                                confirmPopup: {
                                    ...state.confirmPopup,
                                    showConfirmPopup: action.payload.showConfirmPopup,
                                    message: action.payload.message,
                                    showYes: action.payload.isConfirm,
                                    showNo: action.payload.isConfirm,
                                    showOk: action.payload.isInfo,
                                    isComp: action.payload.isComp,
                                    resolve: action.payload.resolve,
                                    title: action.payload.title,
                
                                }
                
                            }
                                    case types.CONFIRM_YES:
                                        if (state.confirmPopup.resolve) {
                                            state.confirmPopup.resolve(true); // Resolving with "true" when confirmed
                                        }
                                        return {
                                            ...state,
                                            confirmPopup: {
                                                ...state.confirmPopup,
                                                showConfirmPopup: false,
                                                message: null,
                                                resolve: null,
                                                showYes: false,
                                                showNo: false,
                                                showOk: false,
                                            }
                            
                                        }
                                    case types.CONFIRM_NO:
                                        if (state.confirmPopup.resolve) {
                                            state.confirmPopup.resolve(false); // Resolving with "true" when confirmed
                                        }  // Resolve the promise with "false"
                                        return {
                                            ...state,
                                            confirmPopup: {
                                                ...state.confirmPopup,
                                                showConfirmPopup: false,
                                                message: null,
                                                resolve: null,
                                                showYes: false,
                                                showNo: false,
                                                showOk: false
                                            }
                            
                                        }
        default:
            return state;
    }
}
// Get Quote  Online Documents upload
